import type { AxiosError, AxiosResponse } from "axios";
import { appConfig } from "models/appConfig";
import { BlueChefAPIClient } from "client/blueChef";
import { client as jspPlatformClient } from "client/jspPlatformExperiment/client.gen";
import { JasperPlatformApiClient } from "client/jspPlatformExperiment";
import { isApiError } from "models/utils/apiUtils";
import "client/axiosRequestConfig";

let apiInstance: JasperPlatformApiClient;

type ErrHandlerFunc = (err: AxiosResponse) => void;

const errorHandlers: ErrHandlerFunc[] = [];

export const addApiErrHandler = (handler: ErrHandlerFunc): void => {
  errorHandlers.push(handler);
};

// v0.92+ uses the shared axios client; attach response interceptor to client.instance once
jspPlatformClient.instance.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    // Run error handlers on error responses (e.g. 401) so AuthProvider can sign out
    const { response } = error;
    if (response) {
      errorHandlers.forEach((func) => func(response));
    }
    return Promise.reject(error);
  },
);

const jspPlatformApi = (): JasperPlatformApiClient => {
  const currToken = localStorage.getItem("accessToken");
  const prevToken = localStorage.getItem("prevAccessToken");

  if (prevToken === currToken && apiInstance) {
    return apiInstance;
  }

  if (currToken !== null && currToken !== undefined) {
    localStorage.setItem("prevAccessToken", currToken);
  }

  // Configure the shared client (baseURL, auth, withCredentials, throwOnError)
  // throwOnError: true so 4xx/5xx reject the promise (pre-upgrade behaviour)
  // global handlers still run via interceptor
  jspPlatformClient.setConfig({
    baseURL: `${appConfig.jspServerUrlRoot}`,
    auth: () => currToken ?? "",
    withCredentials: true,
    throwOnError: true,
  });

  apiInstance = new JasperPlatformApiClient();
  return apiInstance;
};

/**
 * Temporary blue chef client
 */
export const blueChefAPI = new BlueChefAPIClient({
  BASE: `${appConfig.blueChefUrlRoot}`,
});

export default jspPlatformApi;
